import coordinatorQuestionnaire from '@/router/routes/nextEditionDocument/coordinatorQuestionnaire'
import guardianConsent from '@/router/routes/nextEditionDocument/guardianConsent'
import nextEditionChildDocumentService from '@/services/http/api/nextEditionChildDocument'
import type { RouteLocationNormalized } from 'vue-router'

const NextEditionGuardianConsent = () =>
  import('@/views/nextEditionDocument/NextEditionGuardianConsent.vue')

const NextEditionDocument = () => import('@/views/NextEditionDocument.vue')
export default [
  {
    path: '/rekomendacja/:childEditionId',
    component: NextEditionDocument,
    props: true,
    children: [coordinatorQuestionnaire, guardianConsent]
  },
  {
    path: '/zgoda/:hash',
    name: 'GuardianConsentNextEdition',
    component: NextEditionGuardianConsent,
    props: true,
    beforeEnter: async (to: RouteLocationNormalized) => {
      try {
        const hash = to.params.hash as string
        if (!hash) {
          return { name: 'GuardianConsentNextEdirionSummaryNotAvailable' }
        }

        await nextEditionChildDocumentService.nextEditionApplicationCheck(hash)
        // If response is successful (HTTP 200), allow access to the component
        return true
      } catch (e) {
        // If there's any error, redirect to the "not available" summary page
        console.error('Failed to check next edition application status:', e)
        return { name: 'GuardianConsentNextEdirionSummaryNotAvailable' }
      }
    }
  },
  {
    path: '/zgoda/podsumowanie/tak',
    name: 'GuardianConsentNextEdirionSummaryYes',
    component: () => import('@/views/nextEditionDocument/NextEditionGuardianConsentSummaryYes.vue')
  },
  {
    path: '/zgoda/podsumowanie/nie',
    name: 'GuardianConsentNextEdirionSummaryNo',
    component: () => import('@/views/nextEditionDocument/NextEditionGuardianConsentSummaryNo.vue')
  },
  {
    path: '/zgoda/podsumowanie/niedostepne',
    name: 'GuardianConsentNextEdirionSummaryNotAvailable',
    component: () =>
      import('@/views/nextEditionDocument/NextEditionGuardianConsentSummaryNotAvailable.vue')
  }
]
